import "./App.scss"
import Onboarding from './Features/Onboarding';
import TagManager from 'react-gtm-module';

const tagManagerArgs = {
		gtmId: 'GTM-NG3CCNM',
		events: {
			Onboarding: 'Onboarding'
		}
	}

	TagManager.initialize(tagManagerArgs);
function App() {
  return (
    <div className="fluid-container onboarding-container">
      <Onboarding />
    </div>
  );
}

export default App;
